import { FC } from 'react'
import { VerticalFeatureRow } from '@/components/features/VerticalFeatureRow'
import { Section } from '@/components/layout/Section'
import { HeaderBar } from '@/components/HeaderBar'
import { Footer } from '@/components/Footer'
import { Button } from '@fluentui/react-northstar'
import Link from 'next/link'

const Landing: FC = () => {
  return (
    <>
      <HeaderBar showLogOutButton={false} />
      <div className="bg-gray-100">
        <Section
          title="Send Microsoft Teams messages in the future"
          description={
            (
              <>
                Schedule your message to be delivered at the right time.
                <br />
                It's like a time machine, for Microsoft Teams.
              </>
            ) as unknown as string
          }
        >
          <Button
            primary
            as="a"
            href="https://teams.microsoft.com/l/app/ae64c32a-0eab-47d9-91e4-b693a99f7fc3"
            target="_blank"
            className="text-2xl !px-8 !py-6 !mx-4 my-1"
          >
            Open in Teams
          </Button>
          <Link href="/app" passHref legacyBehavior>
            <Button as="a" className="text-2xl !px-8 !py-6 !mx-4 my-1">
              Dashboard
            </Button>
          </Link>
        </Section>
      </div>
      <Section>
        <VerticalFeatureRow
          title="Time your messages"
          description="If you want to say something to someone, but don't want to bother them at the moment, simply schedule the delayed message for the right time and the right chat. Lots of use cases!"
          image="/assets/images/feature.webp"
          imageAlt="Scheduling Microsoft Teams messages to be sent in the future is easy."
        />
        <VerticalFeatureRow
          title="Cancel or reschedule messages"
          description="If you change your mind and the message is no longer necessary, use the dashboard to change the message or its delivery time. Or simply to cancel it altogether."
          image="/assets/images/feature2.webp"
          imageAlt="If you change your mind, you can change the message."
          reverse
        />
        <VerticalFeatureRow
          title="Free to Start, Premium Options"
          description="Delayed Send offers a free plan with basic features and premium options for power users. Check out our pricing page for more details on our Pro and Team plans."
          image="/assets/images/feature3.webp"
          imageAlt="Free and premium pricing plans for Microsoft Teams delayed messaging."
        >
          <div className="mt-6">
            <Link href="/pricing" passHref legacyBehavior>
              <Button primary as="a" className="!px-6 !py-3">
                View Plans Starting at $3/mo
              </Button>
            </Link>
          </div>
        </VerticalFeatureRow>
      </Section>
      <Footer />
    </>
  )
}

export default Landing
